import QSCheckText from './main.vue'
import QSCheckTextInputFirefox from './fireFox.vue'

const isFirefox = navigator.userAgent.includes('Firefox')
const QSCheckTextInput = isFirefox ? QSCheckTextInputFirefox : QSCheckText

export default QSCheckTextInput
